module.exports = __webpack_public_path__ + "static/banner-bg-5350dd87ae641829ad8fa0ff50005ec4.png";